import { farmerService } from './farmerService';
import { productService } from './productService';
import { quoteService } from './quoteService';

export interface DashboardStatistics {
  farmers: {
    total: number;
    active: number;
  };
  products: {
    total: number;
    active: number;
  };
  quotes: {
    total: number;
    draft: number;
    approved: number;
    readyForPayment: number;
    paymentInitiated: number;
  };
  policies: {
    total: number; // Approved quotes = policies
  };
}

class DashboardService {
  /**
   * Get dashboard statistics for the current user's organization
   */
  async getDashboardStatistics(): Promise<DashboardStatistics> {
    try {
      // Fetch all statistics in parallel
      const [farmersResponse, productsResponse, quotesStats] = await Promise.all([
        farmerService.getFarmers({ limit: 1, viewAllOrgs: false }), // Just get pagination info
        productService.getProducts(1, {}, 1, false), // Just get pagination info
        quoteService.getQuoteStatistics(false) // Get quote statistics
      ]);

      // Extract data from response objects
      const quotesData = 'data' in quotesStats ? quotesStats.data : quotesStats;

      return {
        farmers: {
          total: farmersResponse.pagination?.total || 0,
          active: farmersResponse.pagination?.total || 0, // Assuming all are active
        },
        products: {
          total: productsResponse.pagination?.total || 0,
          active: productsResponse.pagination?.total || 0, // Assuming all are active
        },
        quotes: {
          total: quotesData.totalQuotes || 0,
          draft: quotesData.draftQuotes || 0,
          approved: quotesData.approvedQuotes || 0,
          readyForPayment: quotesData.readyForPaymentQuotes || 0,
          paymentInitiated: quotesData.paymentInitiatedQuotes || 0,
        },
        policies: {
          total: quotesData.approvedQuotes || 0, // Approved quotes are policies
        },
      };
    } catch (error) {
      console.error('Error fetching dashboard statistics:', error);
      // Return zeros on error
      return {
        farmers: { total: 0, active: 0 },
        products: { total: 0, active: 0 },
        quotes: { total: 0, draft: 0, approved: 0, readyForPayment: 0, paymentInitiated: 0 },
        policies: { total: 0 },
      };
    }
  }
}

export const dashboardService = new DashboardService();
